<template>
   <div class="wxSubscriptionContainer">
      <router-view></router-view>
   </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.wxSubscriptionContainer{
  height: 100%;
}
</style>

